import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

const DiscountRequestModal = ({
  show,
  onHide,
  onSubmit,
  discountPresets = [],
  submitting = false,
}) => {
  const [presetKey, setPresetKey] = useState('');
  const [requestNote, setRequestNote] = useState('');

  useEffect(() => {
    if (!show) return;
    setPresetKey(discountPresets[0]?.key || '');
    setRequestNote('');
  }, [discountPresets, show]);

  const canSubmit = Boolean(presetKey) && !submitting;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSubmit) return;
    onSubmit({
      presetKey,
      requestNote,
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Request Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info" className="small">
            This sends the request to Corbitt for approval before it can be
            applied to a rating invoice.
          </Alert>

          <Form.Group className="mb-3">
            <Form.Label>Discount</Form.Label>
            <Form.Select
              value={presetKey}
              onChange={(event) => setPresetKey(event.target.value)}
              disabled={submitting}
              required
            >
              {discountPresets.length === 0 ? (
                <option value="">No discount presets available</option>
              ) : null}
              {discountPresets.map((preset) => (
                <option key={preset.key} value={preset.key}>
                  {preset.label} ({preset.percent}%)
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Request note</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={requestNote}
              onChange={(event) => setRequestNote(event.target.value)}
              disabled={submitting}
              placeholder="Why should this claim receive a discount?"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={onHide} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={!canSubmit}>
            {submitting ? 'Sending...' : 'Send Request'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DiscountRequestModal;
